/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import Vue from 'vue';

function mixins() {
  for (var _len = arguments.length, mixins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    mixins2[_key] = arguments[_key];
  }

  return Vue.extend({
    mixins: mixins2
  });
}

export { mixins as default };
//# sourceMappingURL=mixins.js.map
